<template>
  <v-container
    fluid
    grid-list-md
  >
    <v-layout row wrap>
      <v-flex xs12>
        <v-toolbar flat>
          <h2>Классы / Должности</h2>
          <v-spacer></v-spacer>
          <v-text-field
            class="mx-5"
            outlined clearable hide-details dense flat label="фильтр" v-model="search" style="max-width: 300px"
          ></v-text-field>
          <v-dialog
            v-if="studytypedialog === true"
            v-model="studytypedialog"
            scrollable
            persistent :overlay="true"
            max-width="500px"
            transition="dialog-transition"
          >
            <v-card>
              <v-card-title primary-title>
                Выбор формы обучения
              </v-card-title>
              <v-card-text>
                Выберите форму обучения для класса <b>{{ position.name }}</b>
                <v-select
                  :items="studytypes"
                  v-model="position.studytype"
                  label="Выберите форму обучения"
                ></v-select>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  text
                  color="primary"
                  @click="position=null;studytypedialog=false;"
                >Отмена</v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  text
                  :disabled="!this.position || !this.position.studytype"
                  color="primary"
                  @click="changeStudyType()"
                >Сохранить</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog
            v-model="dialogNewPosition"
            scrollable persistent modal
            width="640"
            transition="dialog-transition"
          >
            <template v-slot:activator="{ on }">
              <v-btn class="mr-4" color="primary" v-on="on">Новый класс/должность</v-btn>
            </template>
            <v-card>
              <v-card-title class="subtitle-1">
                Новый класс/должность
                <v-spacer></v-spacer>
                <v-btn icon small @click="dialogNewPositionClose()"><v-icon>close</v-icon></v-btn>
              </v-card-title>
              <v-card-text>

                <v-text-field
                v-model="iname"
                label="Название"
                ></v-text-field>

                <v-select
                v-model="itype"
                :items="['УЧЕНИКИ', 'СОТРУДНИКИ']"
                type="number"
                label="Тип"
                ></v-select>

              </v-card-text>
              <br /><br />

              <v-card-actions>
                <v-btn
                  color="primary"
                  :disabled="inaction || !iname || !itype"
                  @click="addPosition()"
                >
                  Добавить
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn text
                  @click="dialogNewPositionClose()"
                >Отмена</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </v-flex>
      <v-flex>
        <v-data-table no-data="пусто" no-data-text="пусто" no-results-text="ничего не найдено"
          :headers="headers"
          :items="positions"
          :search="search"
          :items-per-page="-1"
          item-key="name" :sort-by="null"
          hide-default-footer
          dense
        >
          <template v-slot:item.studytype="{ item }">
            <span v-if="item.studytype">{{ item.studytype }}-дневка</span>
          </template>
          <template v-slot:item.action="{ item }">
            <v-btn color="blue lighten-1" class="mr-4" x-small text @click="position=item;studytypedialog=true;">
              форма обучения
              <v-icon small>school</v-icon>
            </v-btn>
            <v-btn color="error" class="mr-4" x-small text @click="deleteItem(item)">
              удалить
              <v-icon small>delete</v-icon>
            </v-btn>
          </template>
          <template v-slot:item.cts="{ item }">
            {{ dateFormat(item.cts) }}
          </template>
          <template v-slot:item.arestudents="{ item }">
            <span v-if="item.arestudents === true">УЧЕНИКИ</span>
            <span v-else>СОТРУДНИКИ</span>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment'

const nameRe = /^[0-9а-яА-Я\s]+$/g

export default {
  name: 'Positions',
  data: () => ({
    inaction: false,
    dialogNewPosition: false,
    positions: [],
    search: '',
    headers: [
      { text: 'тип', value: 'arestudents', width: '150' },
      { text: 'имя', value: 'name', width: '150' },
      { text: 'Форма обучения', value: 'studytype', width: '150' },
      { text: 'дата добавления', value: 'cts', width: '150', filter: (value, search, item) => true },
      { text: 'действия', value: 'action', sortable: false },
    ],
    iname: null,
    itype: null,
    studytypedialog: false,
    studytypes: [{ text: '5-дневка', value: 5 }, { text: '6-дневка', value: 6 }],
    position: null
  }),
  methods: {
    async fetch () {
      try {
        const { positions, meta } = await this.$store.dispatch('sioRequest', {
          topic: 'fetch-positions'
        })
        this.positions = positions
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    },
    dialogNewPositionClose () {
      this.dialogNewPosition = false
      this.iname = null
      this.itype = null
    },
    async addPosition () {
      try {
        if (this.inaction) return
        this.inaction = true
        if (!(this.iname.match(nameRe))) {
          throw new Error('В названии можно использовать только киррилические буквы, цифры и знак пробела')
        }
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'add-position',
          pl: {
            name: this.iname,
            arestudents: this.itype === 'УЧЕНИКИ',
          }
        })
        this.$store.dispatch('snack', meta)
        this.dialogNewPositionClose()
      } catch (e) {
        this.$store.dispatch('snack', e)
      } finally {
        this.inaction = false
        this.fetch()
      }
    },
    async deleteItem (item) {
      try {
        await this.$store.dispatch('confirm', `Удалить ${item.name} @ ${item.arestudents ? 'УЧЕНИКИ' : 'СОТРУДНИКИ'} ?`)
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'delete-position',
          pl: {
            positionid: item.positionid
          }
        })
        this.$store.dispatch('snack', meta)
      } catch (e) {
        this.$store.dispatch('snack', e)
      } finally {
        this.fetch()
      }
    },
    async changeStudyType () {
      const { position, meta } = await this.$store.dispatch('sioRequest', {
        topic: 'save-studytype',
        pl: {
          positionid: this.position.positionid,
          studytype: this.position.studytype
        }
      })
      this.studytypedialog = false
      this.position = null
      this.$store.dispatch('snack', meta)
    },
    dateFormat (date) {
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
  },
  computed: {
    profile () {
      return this.$store.state.profile
    },
    scopes () {
      return this.profile ? this.profile.scopes : []
    },
  },
  watch: {
    async profile (val) {
      if (val) await this.fetch()
    }
  },
  mounted () {
    if (this.profile) this.fetch()
  }
}
</script>

<style lang="css">
</style>
